import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "results", "chipContainer", "template", "badgeId"]
  static values = { searchUrl: String, editingBadgeId: String }

  connect() {
    this.timeout = null
    this.fetchId = 0
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    this.fetchId++
  }

  handleInput() {
    if (this.timeout) clearTimeout(this.timeout)

    const query = this.searchInputTarget.value.trim()
    if (query.length < 2) {
      this.clearResults()
      return
    }

    this.timeout = setTimeout(() => this.fetchResults(query), 200)
  }

  async fetchResults(query) {
    const thisFetch = ++this.fetchId
    const url = new URL(this.searchUrlValue, window.location.origin)
    url.searchParams.set("query", query)
    if (this.editingBadgeIdValue) url.searchParams.set("badge_id", this.editingBadgeIdValue)

    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      if (thisFetch !== this.fetchId) return
      if (!response.ok) {
        this.clearResults()
        return
      }
      const items = await response.json()
      if (thisFetch !== this.fetchId) return
      this.renderResults(items)
    } catch (e) {
      console.error("[badge-picker] search failed:", e)
      if (thisFetch === this.fetchId) this.clearResults()
    }
  }

  renderResults(items) {
    this.clearResults()
    if (items.length === 0) {
      const empty = document.createElement("div")
      empty.className = "list-group-item text-muted small"
      empty.textContent = "No matching badges."
      this.resultsTarget.appendChild(empty)
      return
    }

    items.forEach(item => {
      const button = document.createElement("button")
      button.type = "button"
      button.className = "list-group-item list-group-item-action"
      button.dataset.action = "click->badge-picker#selectResult"
      button.dataset.id = item.id
      button.dataset.name = item.name

      const nameEl = document.createElement("strong")
      nameEl.textContent = item.name

      button.appendChild(nameEl)

      if (item.location) {
        const locationEl = document.createElement("span")
        locationEl.className = "text-muted small ms-2"
        locationEl.textContent = item.location
        button.appendChild(locationEl)
      }

      this.resultsTarget.appendChild(button)
    })
  }

  selectResult(event) {
    const button = event.currentTarget
    const { id, name } = button.dataset

    // Single-select: replace any existing chip.
    this.clearChip()

    const fragment = this.templateTarget.content.cloneNode(true)
    fragment.querySelector("[data-badge-id]").dataset.badgeId = id
    fragment.querySelector("[data-name]").textContent = name

    this.chipContainerTarget.appendChild(fragment)
    this.badgeIdTarget.value = id

    this.clearSearch()
  }

  removeChip() {
    this.clearChip()
    this.badgeIdTarget.value = ""
  }

  handleKeydown(event) {
    if (event.key !== "Enter") return
    event.preventDefault()
    const firstResult = this.resultsTarget.querySelector("button[data-id]")
    if (firstResult) firstResult.click()
  }

  clearChip() {
    while (this.chipContainerTarget.firstChild) {
      this.chipContainerTarget.removeChild(this.chipContainerTarget.firstChild)
    }
  }

  clearSearch() {
    this.searchInputTarget.value = ""
    this.clearResults()
  }

  clearResults() {
    while (this.resultsTarget.firstChild) {
      this.resultsTarget.removeChild(this.resultsTarget.firstChild)
    }
  }
}
